import { createModel } from '@rematch/core';
import dayjs from 'dayjs';
import type { RootModel } from '@/models';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { CupomFiscalState } from './types';
import { effects } from './effects';

const initialState: CupomFiscalState = {
    cancelarCupomFiscal: initReduxFn,
    compartilharSend: initReduxFn,

    // VALORES PARA DRAWERS
    dadosCompartilhar: null,
    emitirCupomFiscal: { ...initReduxFn, cancel: false },
    gerarRelatorio: initReduxFn,
    gerarRelatorioMultiple: initReduxFn,
    // EFFECTS
    get: initReduxFn,
    getOne: initReduxFn,

    // TABELAS
    getTable: {
        // FILTROS
        filterDateRange: {
            end: dayjs().endOf('date'),
            start: dayjs().startOf('date').subtract(30, 'day'),
        },

        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // LINHA SELECIONADAS
        selectedRow: undefined,
        selectedRows: [],

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },

        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },
    lancarEstoque: initReduxFn,
    lancarFinanceiro: initReduxFn,
    post: initReduxFn,
    put: initReduxFn,
    remove: initReduxFn,
    showDrawerCancelarNf: false,
    showDrawerCompartilhar: false,
    showDrawerEditar: false,
    showDrawerEmitirNf: false,

    // MOSTRAR DRAWERS
    showDrawerGetDetalhes: false,
    totalizador: initReduxFn,
};

export const CuponsFiscaisModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<CupomFiscalState>(),
    state: initialState,
});
